import DefaultEditor from './default-editor/DefaultEditor';
import HTMLEditor from './html-editor/HTMLEditor';
import { EditorProps } from './types';

const Editor = ({
  editor,
  ...props
}: EditorProps & { editor: 'default' | 'block' | 'kv' | 'html' }) => {
  switch (editor) {
    case 'html':
      return <HTMLEditor {...props} />;
    case 'default':
    default:
      return <DefaultEditor {...props} />;
  }
};

export default Editor;
